'use strict';

class BaMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.activeDropdown = null;
    this.activeTrigger = null;
    this.showTimeout = null;
    this.hideTimeout = null;
    this.SHOW_DELAY = 100;
    this.HIDE_DELAY = 200;
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-overlay]');
    this.l1Items = this.querySelectorAll('[data-nav-trigger]');

    this.l1Items.forEach((trigger) => {
      const parent = trigger.parentElement;

      parent.addEventListener('mouseenter', () => this.handleMouseEnter(trigger));
      parent.addEventListener('mouseleave', () => this.handleMouseLeave());

      trigger.addEventListener('focus', () => this.showDropdown(trigger));
      trigger.addEventListener('keydown', (e) => this.handleKeydown(e, trigger));
    });

    // Close when clicking the overlay
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.hideAllDropdowns());
    }

    // Close on Escape anywhere within the mega menu
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideAllDropdowns();
      }
    });
  }

  handleMouseEnter(trigger) {
    clearTimeout(this.hideTimeout);
    this.hideTimeout = null;

    clearTimeout(this.showTimeout);
    this.showTimeout = setTimeout(() => {
      this.showDropdown(trigger);
    }, this.SHOW_DELAY);
  }

  handleMouseLeave() {
    clearTimeout(this.showTimeout);
    this.showTimeout = null;

    this.hideTimeout = setTimeout(() => {
      this.hideDropdown();
    }, this.HIDE_DELAY);
  }

  handleKeydown(e, trigger) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.hideAllDropdowns();
      trigger.focus();
    }
  }

  showDropdown(trigger) {
    if (this.activeTrigger === trigger) return;

    // Hide any currently open dropdown first
    this.hideDropdown(true);

    const dropdownId = trigger.getAttribute('aria-controls');
    const dropdown = dropdownId ? document.getElementById(dropdownId) : null;

    if (!dropdown) return;

    this.activeTrigger = trigger;
    this.activeDropdown = dropdown;

    trigger.setAttribute('aria-expanded', 'true');
    dropdown.classList.add('is-active');

    if (this.overlay) {
      this.overlay.classList.add('is-active');
    }

    requestAnimationFrame(() => {
      dropdown.style.opacity = '1';
      dropdown.style.visibility = 'visible';
    });
  }

  hideDropdown(immediate) {
    if (!this.activeDropdown) return;

    if (!immediate) {
      clearTimeout(this.showTimeout);
      this.showTimeout = null;
    }

    if (this.activeTrigger) {
      this.activeTrigger.setAttribute('aria-expanded', 'false');
    }

    this.activeDropdown.classList.remove('is-active');
    this.activeDropdown.style.opacity = '';
    this.activeDropdown.style.visibility = '';

    if (this.overlay) {
      this.overlay.classList.remove('is-active');
    }

    this.activeDropdown = null;
    this.activeTrigger = null;
  }

  hideAllDropdowns() {
    clearTimeout(this.showTimeout);
    clearTimeout(this.hideTimeout);
    this.showTimeout = null;
    this.hideTimeout = null;

    const returnFocus = this.activeTrigger;
    this.hideDropdown(true);

    if (returnFocus) {
      returnFocus.focus();
    }
  }

  disconnectedCallback() {
    clearTimeout(this.showTimeout);
    clearTimeout(this.hideTimeout);
  }
}

customElements.define('ba-mega-menu', BaMegaMenu);
